module.exports = __webpack_public_path__ + "static/media/excel.1771a05f.png";